import React from "react";
import { useTranslation } from "react-i18next";
import { ApiInternal } from "src/api/api_internal";
import { SimpleTagDirectory } from "src/api/generated/frontend_internal_v1";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link DeleteTagDirectoryDialog}
 */
export type DeleteTagDirectoryDialogProps = {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** The directory */
    directory: SimpleTagDirectory | undefined;
};

/**
 * A dialog to delete a tag directory.
 */
export default function DeleteTagDirectoryDialog(props: DeleteTagDirectoryDialogProps) {
    const [t] = useTranslation("dialog-tag-directory");

    if (!props.directory) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.directory) return;
                await ApiInternal.tags.deleteDirectory(props.directory.uuid);
                notify.success(t("toast.tag-deleted-successfully"));
                props.onClose();
            }}
            title={t("heading.delete-tag-directory", { directory: props.directory.name })}
            description={t("description.delete-tag-directory")}
            confirmLabel={t("button.delete-tag-directory")}
        />
    );
}
